class ReadMore extends HTMLElement {
  static COLLAPSED_HEIGHT = '96px';  
  static CLAMP_DELAY_MS = 300; // Matches CSS transition time to prevent text jumping

  constructor() {
    super();
    this.resizeObserver = window.ResizeObserver 
      ? new ResizeObserver(() => this.init()) 
      : null;
      
    this.handleToggle = () => this.toggle();
  }

  connectedCallback() {
    this.btn = this.querySelector('.read-more-btn');
    this.content = this.querySelector('.read-more-content');
      
    if (!this.content) return;

    this.init();
    this.resizeObserver?.observe(this.content);
    this.btn?.addEventListener('click', this.handleToggle);
  }

  disconnectedCallback() {
    this.btn?.removeEventListener('click', this.handleToggle);
    this.resizeObserver?.disconnect();
  }

  init() {
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    if (isMobile) {
      const isTruncated = this.content.scrollHeight > this.content.clientHeight;
      const isExpanded = this.classList.contains('is-expanded');

      this.btn?.classList.toggle('hidden', !isTruncated && !isExpanded);
      this.classList.toggle('is-truncated', isTruncated);

      if (!isExpanded) {
        this.content.style.maxHeight = ReadMore.COLLAPSED_HEIGHT;
      } else {
        this.content.style.maxHeight = `${this.content.scrollHeight}px`;
      }
    } else {
      this.btn?.classList.add('hidden');
      this.classList.remove('is-truncated');
      this.content.style.maxHeight = 'none';
    }
  }

  toggle() {
    const isExpanded = this.classList.toggle('is-expanded');
    const readLessText = this.dataset.readLessText; 
    const readMoreText = this.dataset.readMoreText;

    if (isExpanded) {
      this.content.classList.remove('line-clamp-4'); 
      const fullHeight = this.content.scrollHeight;
      this.content.style.maxHeight = `${fullHeight}px`;
    } else {
      this.content.style.maxHeight = ReadMore.COLLAPSED_HEIGHT;

      setTimeout(() => {
        if (!this.classList.contains('is-expanded')) {
          this.content.classList.add('line-clamp-4');
        }
      }, ReadMore.CLAMP_DELAY_MS); 
    }
      
    if (this.btn) {
      this.btn.setAttribute('aria-expanded', isExpanded);
      this.btn.textContent = isExpanded ? readLessText : readMoreText;
    }
  }
}

if (!customElements.get('read-more')) {
  customElements.define('read-more', ReadMore);
}